import {  mapGetters } from 'vuex';
import { errorMessage } from '@/utils/message.js';
import Bus from '../../bus.js';
import registerService from '../../../register-service.js';
import Pagination from '@/components/pagination/index.vue';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      typeArr: [],
      form: {},
      rules: {},
      defaultDoor: false,
      correspondNumberFlag: true,
      dialogVisible: false,
      activeRowId: '', // 选择的联行号
      tableList: [],
      total: 0,
      pageNum: 1,
      pageSize: 10
    };
  },
  computed: {
    ...mapGetters([
      'accName',
      'userType',
      'personMobile'
    ])
  },
  created() {
    this.initForm();
    Bus.$on('msg', (creditCode) => {
      if(!this.defaultDoor){
        console.log(this.defaultDoor, 'this.defaultDoor');
        this.form.taxNo = creditCode;
      }
      console.log('msg', creditCode);
    });
  },
  watch: {
    personMobile: function () {
      this.form.mobile = this.personMobile;
    },
    accName: function () {
      this.form.accName = this.accName;
    }

  },
  methods: {
    initForm() {
      this.rules = {
        accName: [
          { required: true, message: '请输入您的开户名称', trigger: 'change'}
        ],
        accBankCardNo: [
          { required: true, message: '请输入您的银行账号', trigger: 'blur'}
        ],
        bankName: [
          { required: true, message: '请输入开户银行', trigger: 'change'}
        ],
        correspondNumber: [
          { required: false, message: '请输入开户银行联行号', trigger: 'change'}
        ]
      };
      this.form = {
        accName: '',
        accBankCardNo: '',
        bankName: '',
        mobile: '',
        correspondNumber: ''
      };
      if (this.userType === 1) {
        delete this.form.taxNo;
        delete this.rules.taxNo;
        this.form = { ...this.form, mobile: ''};
        this.rules.mobile = [
          { required: true, message: '请输入预留手机号', trigger: 'blur'}
        ];
      } else if (this.userType !== 1) {
        delete this.form.mobile;
        delete this.rules.mobile;
        this.form = { ...this.form, taxNo: ''};
        this.rules.taxNo = [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur'}
        ];
      }
    },
    validateForm() {
      let isValid = false;
      this.$refs['form'].validate(valid => {
        isValid = valid;
      });
      return isValid;
    },
    // 确定
    confirmInput(flag) {
      if(flag === true) {
        if(!this.activeRowId) {
          errorMessage('请选择开户银行联行号');
          return;
        }
        let result = this.tableList.find(item => item.id === this.activeRowId);
        if(result) {
          this.form.bankName = result.bankName;
          this.form.correspondNumber = result.correspondCode;
          this.correspondNumberFlag = true;
        }
      } else {
        this.correspondNumberFlag = false;
      }
      this.activeRowId = '';
      this.dialogVisible = false;
    },
    // 查询 根据输入开户银行进行模糊查询 至少四位
    getByBankNameList(page) {
      console.log(page, 'page');
      if(this.form.bankName && this.form.bankName.length >= 4) {
        this.dialogVisible = true;
        if (page && page.pageNo && page.pageSize) {
          this.pageNum = page.pageNo;
          this.pageSize = page.pageSize;
        }
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          bankName: this.form.bankName
        };
        registerService.getBankCorrespond(params).then(({ code, data }) => {
          if(code === '0') {
            this.tableList = data.list;
            this.total = data.total;
          }
        });
      }
    },
    // 根据银行卡获取开户银行
    getBankAddressByCard(e) {
      if (this.userType === 1 && e.target.value) {
        const accBankCardNo = this.form.accBankCardNo.replace(/\s/g, '');
        this.$store.dispatch('getBankAddressByCard', accBankCardNo).then(res => {
          if (res && res.code === '0') {
            this.form.bankName = res.data && res.data.data && res.data.data.bank;
          } else if (res && res.reason) {
            errorMessage(res.reason);
          } else {
            errorMessage('获取开户银行失败，您可以尝试手动输入开户银行');
          }
        }, error => {
          if (error && error.reason) {
            errorMessage(error.reason);
          } else {
            errorMessage('获取开户银行失败，您可以尝试手动输入开户银行');
          }
        });
      }

      // 根据银行账号查询 开户银行联行号
      if(e.target.value) {
        const accBankCardNo = this.form.accBankCardNo.replace(/\s/g, '');
        this.$store.dispatch('getCorrespondCodeByCardNo', accBankCardNo).then(res => {
          this.form.correspondNumber = '';
          if (res && res.code === '0') {
            this.form.correspondNumber = res.data;
          }
        }, () => {
          this.form.correspondNumber = '';
        });
      }
    },
    // 银行卡号输入格式化为四位一空格
    formateAccBankCardNo () {
      // 获取input的dom对象，这里因为用的是element ui的input，所以需要这样拿到
      const input = this.$refs['accBankCardNo'].$el.firstElementChild;
      const cardNum = input.value;
      // 获取当前光标的位置
      const cursorIndex = input.selectionStart;
      // 字符串中光标之前空格的个数
      const lineNumOfCursorLeft = (cardNum.slice(0, cursorIndex).match(/\s/g) || []).length;
      // 去掉所有空格的字符串
      const noLine = cardNum.replace(/\s/g, '');
      // 去除格式不对的字符并重新插入空格的字符串
      const newCardNum = noLine.replace(/\D+/g, '').replace(/(\d{4})/g, '$1 ').replace(/\s$/, '');
      // 改后字符串中原光标之前空格的个数
      const newLineNumOfCursorLeft = (newCardNum.slice(0, cursorIndex).match(/\s/g) || []).length;
      // 光标在改后字符串中应在的位置
      const newCursorIndex = cursorIndex + newLineNumOfCursorLeft - lineNumOfCursorLeft;
      // 赋新值，nextTick保证空格不能手动输入或删除，只能按照规则自动填入
      this.$nextTick(() => {
        // this.cardNum = newCardNum;
        this.form.accBankCardNo = newCardNum;
        // 修正光标位置，nextTick保证在渲染新值后定位光标
        this.$nextTick(() => {
          // selectionStart、selectionEnd分别代表选择一段文本时的开头和结尾位置
          input.selectionStart = newCursorIndex;
          input.selectionEnd = newCursorIndex;
        });
      });
    }
  }
};
